import { render } from "./RecrutamentoView.vue?vue&type=template&id=3cb3ca2c"
import script from "./RecrutamentoView.vue?vue&type=script&lang=js"
export * from "./RecrutamentoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__